// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/vault/v1/vault.proto" (package "c1.api.vault.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { User } from "../../user/v1/user";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Duration } from "../../../../google/protobuf/duration";
import { Any } from "../../../../google/protobuf/any";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.vault.v1.VaultOpenerServiceOpenRequest
 */
export interface VaultOpenerServiceOpenRequest {
    /**
     * @generated from protobuf field: string vault_id = 1
     */
    vaultId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3
     */
    appUserId: string;
    /**
     * @generated from protobuf field: string credential_id = 4
     */
    credentialId: string;
    /**
     * public key should be a JWK storing a ECDSA public key.
     *
     * @generated from protobuf field: bytes reader_public_key = 5
     */
    readerPublicKey: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultOpenerServiceOpenResponse
 */
export interface VaultOpenerServiceOpenResponse {
    /**
     * Returns a compact JWE encrypted to the reader's public key.
     *
     * @generated from protobuf field: string encrypted_credential = 1
     */
    encryptedCredential: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.AppVaultBinding
 */
export interface AppVaultBinding {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string vault_id = 2
     */
    vaultId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5
     */
    deletedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.vault.v1.AppVaultBindingServiceCreateRequest
 */
export interface AppVaultBindingServiceCreateRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string vault_id = 2
     */
    vaultId: string;
    /**
     * @generated from protobuf field: c1.api.vault.v1.AppVaultBindingExpandMask expand_mask = 3
     */
    expandMask?: AppVaultBindingExpandMask;
}
/**
 * @generated from protobuf message c1.api.vault.v1.AppVaultBindingServiceCreateResponse
 */
export interface AppVaultBindingServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.vault.v1.AppVaultBindingView app_vault_binding_view = 1
     */
    appVaultBindingView?: AppVaultBindingView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.vault.v1.AppVaultBindingServiceDeleteRequest
 */
export interface AppVaultBindingServiceDeleteRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string vault_id = 2
     */
    vaultId: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.AppVaultBindingServiceDeleteResponse
 */
export interface AppVaultBindingServiceDeleteResponse {
}
/**
 * @generated from protobuf message c1.api.vault.v1.AppVaultBindingServiceListRequest
 */
export interface AppVaultBindingServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3
     */
    appId: string;
    /**
     * @generated from protobuf field: c1.api.vault.v1.AppVaultBindingExpandMask expand_mask = 4
     */
    expandMask?: AppVaultBindingExpandMask;
}
/**
 * @generated from protobuf message c1.api.vault.v1.AppVaultBindingServiceListResponse
 */
export interface AppVaultBindingServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.vault.v1.AppVaultBindingView list = 1
     */
    list: AppVaultBindingView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.AppVaultBindingRef
 */
export interface AppVaultBindingRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string vault_id = 2
     */
    vaultId: string;
}
/**
 * The AppUserExpandMask message contains a list of paths to expand in the response.
 *
 * @generated from protobuf message c1.api.vault.v1.AppVaultBindingExpandMask
 */
export interface AppVaultBindingExpandMask {
    /**
     * The paths to expand in the response. May be any combination of "*", "app_id", and "vault_id".
     *
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * The AppVaultBindingView contains an app vault binding as well as paths for apps and vaults in expanded arrays.
 *
 * @generated from protobuf message c1.api.vault.v1.AppVaultBindingView
 */
export interface AppVaultBindingView {
    /**
     * The AppVaultBinding included in this request.
     *
     * @generated from protobuf field: c1.api.vault.v1.AppVaultBinding app_vault_binding = 1
     */
    appVaultBinding?: AppVaultBinding;
    /**
     * JSONPATH expression indicating where the app is expanded in expanded arrays indicated in the request.
     *
     * @generated from protobuf field: string app_path = 2
     */
    appPath: string;
    /**
     * JSONPATH expression indicating where the vault is expanded in expanded arrays indicated in the request.
     *
     * @generated from protobuf field: string vault_path = 3
     */
    vaultPath: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultRef
 */
export interface VaultRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.GroupAuthzVault
 */
export interface GroupAuthzVault {
}
/**
 * @generated from protobuf message c1.api.vault.v1.MagicVault
 */
export interface MagicVault {
    /**
     * @generated from protobuf field: uint32 allowed_views = 1
     */
    allowedViews: number;
    /**
     * @generated from protobuf field: bool allow_unauthed_views = 2
     */
    allowUnauthedViews: boolean;
}
/**
 * @generated from protobuf message c1.api.vault.v1.Vault
 */
export interface Vault {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 4
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string display_name = 5
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 6
     */
    description: string;
    /**
     * Expiration duration for credentials in this vault.
     *
     * @generated from protobuf field: google.protobuf.Duration credential_expiration_duration = 7
     */
    credentialExpirationDuration?: Duration;
    /**
     * @generated from protobuf oneof: vault
     */
    vault: {
        oneofKind: "groupAuthzVault";
        /**
         * @generated from protobuf field: c1.api.vault.v1.GroupAuthzVault group_authz_vault = 100
         */
        groupAuthzVault: GroupAuthzVault;
    } | {
        oneofKind: "magicVault";
        /**
         * @generated from protobuf field: c1.api.vault.v1.MagicVault magic_vault = 101
         */
        magicVault: MagicVault;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceCreateRequest
 */
export interface VaultServiceCreateRequest {
    /**
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: repeated string owner_ids = 4
     */
    ownerIds: string[];
    /**
     * @generated from protobuf oneof: vault
     */
    vault: {
        oneofKind: "groupAuthzVault";
        /**
         * @generated from protobuf field: c1.api.vault.v1.GroupAuthzVault group_authz_vault = 100
         */
        groupAuthzVault: GroupAuthzVault;
    } | {
        oneofKind: "magicVault";
        /**
         * @generated from protobuf field: c1.api.vault.v1.MagicVault magic_vault = 101
         */
        magicVault: MagicVault;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceCreateResponse
 */
export interface VaultServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.vault.v1.Vault vault = 1
     */
    vault?: Vault;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceGetRequest
 */
export interface VaultServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceGetResponse
 */
export interface VaultServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.vault.v1.Vault vault = 1
     */
    vault?: Vault;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceDeleteRequest
 */
export interface VaultServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * Empty response body. Status code indicates success.
 *
 * @generated from protobuf message c1.api.vault.v1.VaultServiceDeleteResponse
 */
export interface VaultServiceDeleteResponse {
}
/**
 * The VaultServiceUpdateRequest message contains the vault object to update and a field mask to indicate which fields to update.
 *
 * @generated from protobuf message c1.api.vault.v1.VaultServiceUpdateRequest
 */
export interface VaultServiceUpdateRequest {
    /**
     * The vault object with the changes to update.
     *
     * @generated from protobuf field: c1.api.vault.v1.Vault vault = 1
     */
    vault?: Vault;
    /**
     * The update mask is a comma-separated string of fields to update.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceUpdateResponse
 */
export interface VaultServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.vault.v1.Vault vault = 1
     */
    vault?: Vault;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceListRequest
 */
export interface VaultServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceListResponse
 */
export interface VaultServiceListResponse {
    /**
     * @generated from protobuf field: repeated c1.api.vault.v1.Vault list = 1
     */
    list: Vault[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceListOwnersRequest
 */
export interface VaultServiceListOwnersRequest {
    /**
     * @generated from protobuf field: string vault_id = 1
     */
    vaultId: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceListOwnersResponse
 */
export interface VaultServiceListOwnersResponse {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User list = 1
     */
    list: User[];
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceSetOwnersRequest
 */
export interface VaultServiceSetOwnersRequest {
    /**
     * @generated from protobuf field: string vault_id = 1
     */
    vaultId: string;
    /**
     * @generated from protobuf field: repeated string user_ids = 2
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceSetOwnersResponse
 */
export interface VaultServiceSetOwnersResponse {
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceSearchRequest
 */
export interface VaultServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.vault.v1.VaultRef refs = 5
     */
    refs: VaultRef[];
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceSearchResponse
 */
export interface VaultServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.vault.v1.Vault list = 1
     */
    list: Vault[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceGetUserCanViewVaultsRequest
 */
export interface VaultServiceGetUserCanViewVaultsRequest {
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceGetUserCanViewVaultsResponse
 */
export interface VaultServiceGetUserCanViewVaultsResponse {
    /**
     * @generated from protobuf field: bool has_any_vaults = 1
     */
    hasAnyVaults: boolean;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceSearchVaultsForOwnerRequest
 */
export interface VaultServiceSearchVaultsForOwnerRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.vault.v1.VaultServiceSearchVaultsForOwnerResponse
 */
export interface VaultServiceSearchVaultsForOwnerResponse {
    /**
     * @generated from protobuf field: repeated c1.api.vault.v1.Vault list = 1
     */
    list: Vault[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class VaultOpenerServiceOpenRequest$Type extends MessageType<VaultOpenerServiceOpenRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultOpenerServiceOpenRequest", [
            { no: 1, name: "vault_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "credential_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "reader_public_key", kind: "scalar", T: 12 /*ScalarType.BYTES*/ }
        ]);
    }
    create(value?: PartialMessage<VaultOpenerServiceOpenRequest>): VaultOpenerServiceOpenRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.vaultId = "";
        message.appId = "";
        message.appUserId = "";
        message.credentialId = "";
        message.readerPublicKey = new Uint8Array(0);
        if (value !== undefined)
            reflectionMergePartial<VaultOpenerServiceOpenRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultOpenerServiceOpenRequest): VaultOpenerServiceOpenRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string vault_id */ 1:
                    message.vaultId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string app_user_id */ 3:
                    message.appUserId = reader.string();
                    break;
                case /* string credential_id */ 4:
                    message.credentialId = reader.string();
                    break;
                case /* bytes reader_public_key */ 5:
                    message.readerPublicKey = reader.bytes();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultOpenerServiceOpenRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string vault_id = 1; */
        if (message.vaultId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.vaultId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string app_user_id = 3; */
        if (message.appUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserId);
        /* string credential_id = 4; */
        if (message.credentialId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.credentialId);
        /* bytes reader_public_key = 5; */
        if (message.readerPublicKey.length)
            writer.tag(5, WireType.LengthDelimited).bytes(message.readerPublicKey);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultOpenerServiceOpenRequest
 */
export const VaultOpenerServiceOpenRequest = new VaultOpenerServiceOpenRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultOpenerServiceOpenResponse$Type extends MessageType<VaultOpenerServiceOpenResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultOpenerServiceOpenResponse", [
            { no: 1, name: "encrypted_credential", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VaultOpenerServiceOpenResponse>): VaultOpenerServiceOpenResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.encryptedCredential = "";
        if (value !== undefined)
            reflectionMergePartial<VaultOpenerServiceOpenResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultOpenerServiceOpenResponse): VaultOpenerServiceOpenResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string encrypted_credential */ 1:
                    message.encryptedCredential = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultOpenerServiceOpenResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string encrypted_credential = 1; */
        if (message.encryptedCredential !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.encryptedCredential);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultOpenerServiceOpenResponse
 */
export const VaultOpenerServiceOpenResponse = new VaultOpenerServiceOpenResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBinding$Type extends MessageType<AppVaultBinding> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBinding", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "vault_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<AppVaultBinding>): AppVaultBinding {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.vaultId = "";
        if (value !== undefined)
            reflectionMergePartial<AppVaultBinding>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppVaultBinding): AppVaultBinding {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string vault_id */ 2:
                    message.vaultId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 4:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 5:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppVaultBinding, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string vault_id = 2; */
        if (message.vaultId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.vaultId);
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 4; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 5; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBinding
 */
export const AppVaultBinding = new AppVaultBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBindingServiceCreateRequest$Type extends MessageType<AppVaultBindingServiceCreateRequest> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBindingServiceCreateRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "vault_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppVaultBindingExpandMask }
        ]);
    }
    create(value?: PartialMessage<AppVaultBindingServiceCreateRequest>): AppVaultBindingServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.vaultId = "";
        if (value !== undefined)
            reflectionMergePartial<AppVaultBindingServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppVaultBindingServiceCreateRequest): AppVaultBindingServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string vault_id */ 2:
                    message.vaultId = reader.string();
                    break;
                case /* c1.api.vault.v1.AppVaultBindingExpandMask expand_mask */ 3:
                    message.expandMask = AppVaultBindingExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppVaultBindingServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string vault_id = 2; */
        if (message.vaultId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.vaultId);
        /* c1.api.vault.v1.AppVaultBindingExpandMask expand_mask = 3; */
        if (message.expandMask)
            AppVaultBindingExpandMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBindingServiceCreateRequest
 */
export const AppVaultBindingServiceCreateRequest = new AppVaultBindingServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBindingServiceCreateResponse$Type extends MessageType<AppVaultBindingServiceCreateResponse> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBindingServiceCreateResponse", [
            { no: 1, name: "app_vault_binding_view", kind: "message", T: () => AppVaultBindingView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<AppVaultBindingServiceCreateResponse>): AppVaultBindingServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<AppVaultBindingServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppVaultBindingServiceCreateResponse): AppVaultBindingServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.vault.v1.AppVaultBindingView app_vault_binding_view */ 1:
                    message.appVaultBindingView = AppVaultBindingView.internalBinaryRead(reader, reader.uint32(), options, message.appVaultBindingView);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppVaultBindingServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.vault.v1.AppVaultBindingView app_vault_binding_view = 1; */
        if (message.appVaultBindingView)
            AppVaultBindingView.internalBinaryWrite(message.appVaultBindingView, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBindingServiceCreateResponse
 */
export const AppVaultBindingServiceCreateResponse = new AppVaultBindingServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBindingServiceDeleteRequest$Type extends MessageType<AppVaultBindingServiceDeleteRequest> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBindingServiceDeleteRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "vault_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AppVaultBindingServiceDeleteRequest>): AppVaultBindingServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.vaultId = "";
        if (value !== undefined)
            reflectionMergePartial<AppVaultBindingServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppVaultBindingServiceDeleteRequest): AppVaultBindingServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string vault_id */ 2:
                    message.vaultId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppVaultBindingServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string vault_id = 2; */
        if (message.vaultId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.vaultId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBindingServiceDeleteRequest
 */
export const AppVaultBindingServiceDeleteRequest = new AppVaultBindingServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBindingServiceDeleteResponse$Type extends MessageType<AppVaultBindingServiceDeleteResponse> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBindingServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<AppVaultBindingServiceDeleteResponse>): AppVaultBindingServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppVaultBindingServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppVaultBindingServiceDeleteResponse): AppVaultBindingServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppVaultBindingServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBindingServiceDeleteResponse
 */
export const AppVaultBindingServiceDeleteResponse = new AppVaultBindingServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBindingServiceListRequest$Type extends MessageType<AppVaultBindingServiceListRequest> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBindingServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppVaultBindingExpandMask }
        ]);
    }
    create(value?: PartialMessage<AppVaultBindingServiceListRequest>): AppVaultBindingServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<AppVaultBindingServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppVaultBindingServiceListRequest): AppVaultBindingServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string app_id */ 3:
                    message.appId = reader.string();
                    break;
                case /* c1.api.vault.v1.AppVaultBindingExpandMask expand_mask */ 4:
                    message.expandMask = AppVaultBindingExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppVaultBindingServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string app_id = 3; */
        if (message.appId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appId);
        /* c1.api.vault.v1.AppVaultBindingExpandMask expand_mask = 4; */
        if (message.expandMask)
            AppVaultBindingExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBindingServiceListRequest
 */
export const AppVaultBindingServiceListRequest = new AppVaultBindingServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBindingServiceListResponse$Type extends MessageType<AppVaultBindingServiceListResponse> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBindingServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppVaultBindingView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppVaultBindingServiceListResponse>): AppVaultBindingServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<AppVaultBindingServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppVaultBindingServiceListResponse): AppVaultBindingServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.vault.v1.AppVaultBindingView list */ 1:
                    message.list.push(AppVaultBindingView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppVaultBindingServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.vault.v1.AppVaultBindingView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppVaultBindingView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBindingServiceListResponse
 */
export const AppVaultBindingServiceListResponse = new AppVaultBindingServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBindingRef$Type extends MessageType<AppVaultBindingRef> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBindingRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "vault_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<AppVaultBindingRef>): AppVaultBindingRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.vaultId = "";
        if (value !== undefined)
            reflectionMergePartial<AppVaultBindingRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppVaultBindingRef): AppVaultBindingRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string vault_id */ 2:
                    message.vaultId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppVaultBindingRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string vault_id = 2; */
        if (message.vaultId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.vaultId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBindingRef
 */
export const AppVaultBindingRef = new AppVaultBindingRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBindingExpandMask$Type extends MessageType<AppVaultBindingExpandMask> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBindingExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "vault_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AppVaultBindingExpandMask>): AppVaultBindingExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AppVaultBindingExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppVaultBindingExpandMask): AppVaultBindingExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppVaultBindingExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBindingExpandMask
 */
export const AppVaultBindingExpandMask = new AppVaultBindingExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppVaultBindingView$Type extends MessageType<AppVaultBindingView> {
    constructor() {
        super("c1.api.vault.v1.AppVaultBindingView", [
            { no: 1, name: "app_vault_binding", kind: "message", T: () => AppVaultBinding },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "vault_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppVaultBindingView>): AppVaultBindingView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appPath = "";
        message.vaultPath = "";
        if (value !== undefined)
            reflectionMergePartial<AppVaultBindingView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppVaultBindingView): AppVaultBindingView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.vault.v1.AppVaultBinding app_vault_binding */ 1:
                    message.appVaultBinding = AppVaultBinding.internalBinaryRead(reader, reader.uint32(), options, message.appVaultBinding);
                    break;
                case /* string app_path */ 2:
                    message.appPath = reader.string();
                    break;
                case /* string vault_path */ 3:
                    message.vaultPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppVaultBindingView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.vault.v1.AppVaultBinding app_vault_binding = 1; */
        if (message.appVaultBinding)
            AppVaultBinding.internalBinaryWrite(message.appVaultBinding, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_path = 2; */
        if (message.appPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appPath);
        /* string vault_path = 3; */
        if (message.vaultPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.vaultPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.AppVaultBindingView
 */
export const AppVaultBindingView = new AppVaultBindingView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultRef$Type extends MessageType<VaultRef> {
    constructor() {
        super("c1.api.vault.v1.VaultRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<VaultRef>): VaultRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<VaultRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultRef): VaultRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultRef
 */
export const VaultRef = new VaultRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GroupAuthzVault$Type extends MessageType<GroupAuthzVault> {
    constructor() {
        super("c1.api.vault.v1.GroupAuthzVault", []);
    }
    create(value?: PartialMessage<GroupAuthzVault>): GroupAuthzVault {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GroupAuthzVault>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GroupAuthzVault): GroupAuthzVault {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GroupAuthzVault, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.GroupAuthzVault
 */
export const GroupAuthzVault = new GroupAuthzVault$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MagicVault$Type extends MessageType<MagicVault> {
    constructor() {
        super("c1.api.vault.v1.MagicVault", [
            { no: 1, name: "allowed_views", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "allow_unauthed_views", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<MagicVault>): MagicVault {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.allowedViews = 0;
        message.allowUnauthedViews = false;
        if (value !== undefined)
            reflectionMergePartial<MagicVault>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MagicVault): MagicVault {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 allowed_views */ 1:
                    message.allowedViews = reader.uint32();
                    break;
                case /* bool allow_unauthed_views */ 2:
                    message.allowUnauthedViews = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MagicVault, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 allowed_views = 1; */
        if (message.allowedViews !== 0)
            writer.tag(1, WireType.Varint).uint32(message.allowedViews);
        /* bool allow_unauthed_views = 2; */
        if (message.allowUnauthedViews !== false)
            writer.tag(2, WireType.Varint).bool(message.allowUnauthedViews);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.MagicVault
 */
export const MagicVault = new MagicVault$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Vault$Type extends MessageType<Vault> {
    constructor() {
        super("c1.api.vault.v1.Vault", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "3", maxLen: "1024" } } } },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "0", maxLen: "8192" } } } },
            { no: 7, name: "credential_expiration_duration", kind: "message", T: () => Duration },
            { no: 100, name: "group_authz_vault", kind: "message", oneof: "vault", T: () => GroupAuthzVault },
            { no: 101, name: "magic_vault", kind: "message", oneof: "vault", T: () => MagicVault }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Vault" } }] } });
    }
    create(value?: PartialMessage<Vault>): Vault {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.description = "";
        message.vault = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<Vault>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Vault): Vault {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 3:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 4:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* string display_name */ 5:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 6:
                    message.description = reader.string();
                    break;
                case /* google.protobuf.Duration credential_expiration_duration */ 7:
                    message.credentialExpirationDuration = Duration.internalBinaryRead(reader, reader.uint32(), options, message.credentialExpirationDuration);
                    break;
                case /* c1.api.vault.v1.GroupAuthzVault group_authz_vault */ 100:
                    message.vault = {
                        oneofKind: "groupAuthzVault",
                        groupAuthzVault: GroupAuthzVault.internalBinaryRead(reader, reader.uint32(), options, (message.vault as any).groupAuthzVault)
                    };
                    break;
                case /* c1.api.vault.v1.MagicVault magic_vault */ 101:
                    message.vault = {
                        oneofKind: "magicVault",
                        magicVault: MagicVault.internalBinaryRead(reader, reader.uint32(), options, (message.vault as any).magicVault)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Vault, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 3; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 4; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string display_name = 5; */
        if (message.displayName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.displayName);
        /* string description = 6; */
        if (message.description !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.description);
        /* google.protobuf.Duration credential_expiration_duration = 7; */
        if (message.credentialExpirationDuration)
            Duration.internalBinaryWrite(message.credentialExpirationDuration, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.vault.v1.GroupAuthzVault group_authz_vault = 100; */
        if (message.vault.oneofKind === "groupAuthzVault")
            GroupAuthzVault.internalBinaryWrite(message.vault.groupAuthzVault, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.vault.v1.MagicVault magic_vault = 101; */
        if (message.vault.oneofKind === "magicVault")
            MagicVault.internalBinaryWrite(message.vault.magicVault, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.Vault
 */
export const Vault = new Vault$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceCreateRequest$Type extends MessageType<VaultServiceCreateRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] }, "validate.rules": { string: { minLen: "3", maxLen: "1024" } } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "0", maxLen: "8192" } } } },
            { no: 4, name: "owner_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "10", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 100, name: "group_authz_vault", kind: "message", oneof: "vault", T: () => GroupAuthzVault },
            { no: 101, name: "magic_vault", kind: "message", oneof: "vault", T: () => MagicVault }
        ]);
    }
    create(value?: PartialMessage<VaultServiceCreateRequest>): VaultServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.description = "";
        message.ownerIds = [];
        message.vault = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<VaultServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceCreateRequest): VaultServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* repeated string owner_ids */ 4:
                    message.ownerIds.push(reader.string());
                    break;
                case /* c1.api.vault.v1.GroupAuthzVault group_authz_vault */ 100:
                    message.vault = {
                        oneofKind: "groupAuthzVault",
                        groupAuthzVault: GroupAuthzVault.internalBinaryRead(reader, reader.uint32(), options, (message.vault as any).groupAuthzVault)
                    };
                    break;
                case /* c1.api.vault.v1.MagicVault magic_vault */ 101:
                    message.vault = {
                        oneofKind: "magicVault",
                        magicVault: MagicVault.internalBinaryRead(reader, reader.uint32(), options, (message.vault as any).magicVault)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* repeated string owner_ids = 4; */
        for (let i = 0; i < message.ownerIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.ownerIds[i]);
        /* c1.api.vault.v1.GroupAuthzVault group_authz_vault = 100; */
        if (message.vault.oneofKind === "groupAuthzVault")
            GroupAuthzVault.internalBinaryWrite(message.vault.groupAuthzVault, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.vault.v1.MagicVault magic_vault = 101; */
        if (message.vault.oneofKind === "magicVault")
            MagicVault.internalBinaryWrite(message.vault.magicVault, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceCreateRequest
 */
export const VaultServiceCreateRequest = new VaultServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceCreateResponse$Type extends MessageType<VaultServiceCreateResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceCreateResponse", [
            { no: 1, name: "vault", kind: "message", T: () => Vault }
        ]);
    }
    create(value?: PartialMessage<VaultServiceCreateResponse>): VaultServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<VaultServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceCreateResponse): VaultServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.vault.v1.Vault vault */ 1:
                    message.vault = Vault.internalBinaryRead(reader, reader.uint32(), options, message.vault);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.vault.v1.Vault vault = 1; */
        if (message.vault)
            Vault.internalBinaryWrite(message.vault, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceCreateResponse
 */
export const VaultServiceCreateResponse = new VaultServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceGetRequest$Type extends MessageType<VaultServiceGetRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<VaultServiceGetRequest>): VaultServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<VaultServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceGetRequest): VaultServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceGetRequest
 */
export const VaultServiceGetRequest = new VaultServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceGetResponse$Type extends MessageType<VaultServiceGetResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceGetResponse", [
            { no: 1, name: "vault", kind: "message", T: () => Vault }
        ]);
    }
    create(value?: PartialMessage<VaultServiceGetResponse>): VaultServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<VaultServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceGetResponse): VaultServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.vault.v1.Vault vault */ 1:
                    message.vault = Vault.internalBinaryRead(reader, reader.uint32(), options, message.vault);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.vault.v1.Vault vault = 1; */
        if (message.vault)
            Vault.internalBinaryWrite(message.vault, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceGetResponse
 */
export const VaultServiceGetResponse = new VaultServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceDeleteRequest$Type extends MessageType<VaultServiceDeleteRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<VaultServiceDeleteRequest>): VaultServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<VaultServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceDeleteRequest): VaultServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceDeleteRequest
 */
export const VaultServiceDeleteRequest = new VaultServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceDeleteResponse$Type extends MessageType<VaultServiceDeleteResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<VaultServiceDeleteResponse>): VaultServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<VaultServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceDeleteResponse): VaultServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceDeleteResponse
 */
export const VaultServiceDeleteResponse = new VaultServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceUpdateRequest$Type extends MessageType<VaultServiceUpdateRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceUpdateRequest", [
            { no: 1, name: "vault", kind: "message", T: () => Vault },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<VaultServiceUpdateRequest>): VaultServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<VaultServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceUpdateRequest): VaultServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.vault.v1.Vault vault */ 1:
                    message.vault = Vault.internalBinaryRead(reader, reader.uint32(), options, message.vault);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.vault.v1.Vault vault = 1; */
        if (message.vault)
            Vault.internalBinaryWrite(message.vault, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceUpdateRequest
 */
export const VaultServiceUpdateRequest = new VaultServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceUpdateResponse$Type extends MessageType<VaultServiceUpdateResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceUpdateResponse", [
            { no: 1, name: "vault", kind: "message", T: () => Vault }
        ]);
    }
    create(value?: PartialMessage<VaultServiceUpdateResponse>): VaultServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<VaultServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceUpdateResponse): VaultServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.vault.v1.Vault vault */ 1:
                    message.vault = Vault.internalBinaryRead(reader, reader.uint32(), options, message.vault);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.vault.v1.Vault vault = 1; */
        if (message.vault)
            Vault.internalBinaryWrite(message.vault, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceUpdateResponse
 */
export const VaultServiceUpdateResponse = new VaultServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceListRequest$Type extends MessageType<VaultServiceListRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
    create(value?: PartialMessage<VaultServiceListRequest>): VaultServiceListRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<VaultServiceListRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceListRequest): VaultServiceListRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceListRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceListRequest
 */
export const VaultServiceListRequest = new VaultServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceListResponse$Type extends MessageType<VaultServiceListResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Vault },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VaultServiceListResponse>): VaultServiceListResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<VaultServiceListResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceListResponse): VaultServiceListResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.vault.v1.Vault list */ 1:
                    message.list.push(Vault.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceListResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.vault.v1.Vault list = 1; */
        for (let i = 0; i < message.list.length; i++)
            Vault.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceListResponse
 */
export const VaultServiceListResponse = new VaultServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceListOwnersRequest$Type extends MessageType<VaultServiceListOwnersRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceListOwnersRequest", [
            { no: 1, name: "vault_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<VaultServiceListOwnersRequest>): VaultServiceListOwnersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.vaultId = "";
        if (value !== undefined)
            reflectionMergePartial<VaultServiceListOwnersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceListOwnersRequest): VaultServiceListOwnersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string vault_id */ 1:
                    message.vaultId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceListOwnersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string vault_id = 1; */
        if (message.vaultId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.vaultId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceListOwnersRequest
 */
export const VaultServiceListOwnersRequest = new VaultServiceListOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceListOwnersResponse$Type extends MessageType<VaultServiceListOwnersResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceListOwnersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
    create(value?: PartialMessage<VaultServiceListOwnersResponse>): VaultServiceListOwnersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<VaultServiceListOwnersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceListOwnersResponse): VaultServiceListOwnersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.user.v1.User list */ 1:
                    message.list.push(User.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceListOwnersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.user.v1.User list = 1; */
        for (let i = 0; i < message.list.length; i++)
            User.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceListOwnersResponse
 */
export const VaultServiceListOwnersResponse = new VaultServiceListOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceSetOwnersRequest$Type extends MessageType<VaultServiceSetOwnersRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceSetOwnersRequest", [
            { no: 1, name: "vault_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "10", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<VaultServiceSetOwnersRequest>): VaultServiceSetOwnersRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.vaultId = "";
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<VaultServiceSetOwnersRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceSetOwnersRequest): VaultServiceSetOwnersRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string vault_id */ 1:
                    message.vaultId = reader.string();
                    break;
                case /* repeated string user_ids */ 2:
                    message.userIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceSetOwnersRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string vault_id = 1; */
        if (message.vaultId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.vaultId);
        /* repeated string user_ids = 2; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.userIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceSetOwnersRequest
 */
export const VaultServiceSetOwnersRequest = new VaultServiceSetOwnersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceSetOwnersResponse$Type extends MessageType<VaultServiceSetOwnersResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceSetOwnersResponse", []);
    }
    create(value?: PartialMessage<VaultServiceSetOwnersResponse>): VaultServiceSetOwnersResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<VaultServiceSetOwnersResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceSetOwnersResponse): VaultServiceSetOwnersResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceSetOwnersResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceSetOwnersResponse
 */
export const VaultServiceSetOwnersResponse = new VaultServiceSetOwnersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceSearchRequest$Type extends MessageType<VaultServiceSearchRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => VaultRef }
        ]);
    }
    create(value?: PartialMessage<VaultServiceSearchRequest>): VaultServiceSearchRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<VaultServiceSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceSearchRequest): VaultServiceSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated c1.api.vault.v1.VaultRef refs */ 5:
                    message.refs.push(VaultRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated c1.api.vault.v1.VaultRef refs = 5; */
        for (let i = 0; i < message.refs.length; i++)
            VaultRef.internalBinaryWrite(message.refs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceSearchRequest
 */
export const VaultServiceSearchRequest = new VaultServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceSearchResponse$Type extends MessageType<VaultServiceSearchResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Vault },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VaultServiceSearchResponse>): VaultServiceSearchResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<VaultServiceSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceSearchResponse): VaultServiceSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.vault.v1.Vault list */ 1:
                    message.list.push(Vault.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.vault.v1.Vault list = 1; */
        for (let i = 0; i < message.list.length; i++)
            Vault.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceSearchResponse
 */
export const VaultServiceSearchResponse = new VaultServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceGetUserCanViewVaultsRequest$Type extends MessageType<VaultServiceGetUserCanViewVaultsRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceGetUserCanViewVaultsRequest", []);
    }
    create(value?: PartialMessage<VaultServiceGetUserCanViewVaultsRequest>): VaultServiceGetUserCanViewVaultsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<VaultServiceGetUserCanViewVaultsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceGetUserCanViewVaultsRequest): VaultServiceGetUserCanViewVaultsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceGetUserCanViewVaultsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceGetUserCanViewVaultsRequest
 */
export const VaultServiceGetUserCanViewVaultsRequest = new VaultServiceGetUserCanViewVaultsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceGetUserCanViewVaultsResponse$Type extends MessageType<VaultServiceGetUserCanViewVaultsResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceGetUserCanViewVaultsResponse", [
            { no: 1, name: "has_any_vaults", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<VaultServiceGetUserCanViewVaultsResponse>): VaultServiceGetUserCanViewVaultsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.hasAnyVaults = false;
        if (value !== undefined)
            reflectionMergePartial<VaultServiceGetUserCanViewVaultsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceGetUserCanViewVaultsResponse): VaultServiceGetUserCanViewVaultsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool has_any_vaults */ 1:
                    message.hasAnyVaults = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceGetUserCanViewVaultsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool has_any_vaults = 1; */
        if (message.hasAnyVaults !== false)
            writer.tag(1, WireType.Varint).bool(message.hasAnyVaults);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceGetUserCanViewVaultsResponse
 */
export const VaultServiceGetUserCanViewVaultsResponse = new VaultServiceGetUserCanViewVaultsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceSearchVaultsForOwnerRequest$Type extends MessageType<VaultServiceSearchVaultsForOwnerRequest> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceSearchVaultsForOwnerRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VaultServiceSearchVaultsForOwnerRequest>): VaultServiceSearchVaultsForOwnerRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        if (value !== undefined)
            reflectionMergePartial<VaultServiceSearchVaultsForOwnerRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceSearchVaultsForOwnerRequest): VaultServiceSearchVaultsForOwnerRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceSearchVaultsForOwnerRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceSearchVaultsForOwnerRequest
 */
export const VaultServiceSearchVaultsForOwnerRequest = new VaultServiceSearchVaultsForOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class VaultServiceSearchVaultsForOwnerResponse$Type extends MessageType<VaultServiceSearchVaultsForOwnerResponse> {
    constructor() {
        super("c1.api.vault.v1.VaultServiceSearchVaultsForOwnerResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Vault },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<VaultServiceSearchVaultsForOwnerResponse>): VaultServiceSearchVaultsForOwnerResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<VaultServiceSearchVaultsForOwnerResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: VaultServiceSearchVaultsForOwnerResponse): VaultServiceSearchVaultsForOwnerResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.vault.v1.Vault list */ 1:
                    message.list.push(Vault.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: VaultServiceSearchVaultsForOwnerResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.vault.v1.Vault list = 1; */
        for (let i = 0; i < message.list.length; i++)
            Vault.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.vault.v1.VaultServiceSearchVaultsForOwnerResponse
 */
export const VaultServiceSearchVaultsForOwnerResponse = new VaultServiceSearchVaultsForOwnerResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.vault.v1.VaultService
 */
export const VaultService = new ServiceType("c1.api.vault.v1.VaultService", [
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: VaultServiceListRequest, O: VaultServiceListResponse },
    { name: "Get", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/vaults/{id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Vault", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "Vault" }] }, "authz.method": { role: "VIEWER" } }, I: VaultServiceGetRequest, O: VaultServiceGetResponse },
    { name: "Create", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/vaults", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Vault" }], group: "Vault" }] }, "authz.method": { role: "EDITOR" } }, I: VaultServiceCreateRequest, O: VaultServiceCreateResponse },
    { name: "Delete", options: { "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/vaults/{id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Vault" }], group: "Vault" }] }, "authz.method": { role: "EDITOR" } }, I: VaultServiceDeleteRequest, O: VaultServiceDeleteResponse },
    { name: "Update", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/vaults/{vault.id}", stability: "STABILITY_DRAFT", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Vault" }], group: "Vault" }] }, "authz.method": { role: "EDITOR" } }, I: VaultServiceUpdateRequest, O: VaultServiceUpdateResponse },
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: VaultServiceSearchRequest, O: VaultServiceSearchResponse },
    { name: "SearchVaultsForOwner", options: { "authz.method": { role: "VIEWER" } }, I: VaultServiceSearchVaultsForOwnerRequest, O: VaultServiceSearchVaultsForOwnerResponse },
    { name: "ListOwners", options: { "authz.method": { role: "VIEWER" } }, I: VaultServiceListOwnersRequest, O: VaultServiceListOwnersResponse },
    { name: "SetOwners", options: { "authz.method": { role: "EDITOR" } }, I: VaultServiceSetOwnersRequest, O: VaultServiceSetOwnersResponse },
    { name: "GetUserCanViewVaults", options: { "authz.method": { role: "VIEWER" } }, I: VaultServiceGetUserCanViewVaultsRequest, O: VaultServiceGetUserCanViewVaultsResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.vault.v1.AppVaultBindingService
 */
export const AppVaultBindingService = new ServiceType("c1.api.vault.v1.AppVaultBindingService", [
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: AppVaultBindingServiceCreateRequest, O: AppVaultBindingServiceCreateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: AppVaultBindingServiceDeleteRequest, O: AppVaultBindingServiceDeleteResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: AppVaultBindingServiceListRequest, O: AppVaultBindingServiceListResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.vault.v1.VaultOpenerService
 */
export const VaultOpenerService = new ServiceType("c1.api.vault.v1.VaultOpenerService", [
    { name: "Open", options: { "authz.method": { role: "VIEWER" } }, I: VaultOpenerServiceOpenRequest, O: VaultOpenerServiceOpenResponse }
]);
